// extracted by mini-css-extract-plugin
export default {"option":"DiscountsField_option__azq1l","wrapper":"DiscountsField_wrapper__vaga-"};